import { DiContainerInjectFn } from '@@/di/ts';
import { AuthService } from '@@/auth/services/auth.service';
import { AuthMockService } from '@@/auth/services/auth-mock.service';

export default ((container) => {
  container.bind(AuthService).toSelf().inSingletonScope();
  // container.bind(AuthService).to(AuthMockService).inSingletonScope();
}) as DiContainerInjectFn;
